import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import './styles.scss';

interface Props {
  children: Array<React.ReactElement>;
}

const Highlights: React.FC<Props> = ({ children }) => {
  return (
    <Row className="high-lights">
      {children.map((component, index, array) => (
        <Col key={index} className="high-lights-col" xs={6} sm={array.length < 5 ? 6 : 4} xl={true}>
          {component}
        </Col>
      ))}
    </Row>
  );
};

export default Highlights;
